import { useOutletContext } from 'react-router-dom';
import { OutletContextType } from '@/types';
function useOutlet() {
  return useOutletContext<OutletContextType>();
}

export {
  useOutlet,
};
